// extracted by mini-css-extract-plugin
export default {"vmpsHeader":"Information_vmpsHeader__3IPX2"};